/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PcmsHubAdultReferralResponse { 
    compasPersonId?: string;
    crdProgramNumber?: number;
    crdReferralId?: string;
    pcmsIndividualId?: number;
    referralStatus?: PcmsHubAdultReferralResponse.ReferralStatusEnum;
    sourceCreatedAt?: string;
    taskReferralDate?: string;
}
export namespace PcmsHubAdultReferralResponse {
    export const ReferralStatusEnum = {
        Pending: 'PENDING',
        Accepted: 'ACCEPTED',
        Active: 'ACTIVE',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED',
        Rejected: 'REJECTED',
        Removed: 'REMOVED'
    } as const;
    export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];
}


